import { X } from "lucide-react";
import { cn } from "@/utils/css";

export const ClearableInput = ({ value, onChange, placeholder = "", className = "", disabled = false, error = false, ...rest }) => {
    return (
        <div className="relative">
            <input
                type="text"
                value={value}
                placeholder={placeholder}
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}
                className={cn(
                    "w-full bg-cm-p-surface-container rounded-[6px] px-3 pr-9 py-2 h-[40px] text-cm-p-text-primary text-[15px] font-medium border outline-none focus:ring-0 focus:shadow-none focus:outline-none placeholder:text-[15px] placeholder:font-normal placeholder:text-cm-p-text-secondary",
                    {
                        "opacity-50 cursor-not-allowed": disabled,
                        "border-cm-p-on-container-red": error,
                        "border-cm-p-outline": !error,
                    },
                    className,
                )}
                {...rest}
            />
            {value && !disabled && (
                <button
                    type="button"
                    onClick={() => onChange("")}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-cm-p-text-secondary hover:text-cm-p-text-primary"
                >
                    <X className="w-4 h-4" />
                </button>
            )}
        </div>
    );
};
